import React, {useState} from 'react';
import {Input, Space} from "antd";

export default ({value, onChange, ...props}) => {
  const [values, setValues] = useState(value ? value.split("-") : []);

  let updateValue = (pos, v) => {
    values[pos] = v;
    setValues(values);

    onChange(values.join("-"));
  }

  let changeD = e => {
    let v = e.target.value;

    if (!v.match(/^(|\d|[012]\d|3[01])$/))
      return;

    updateValue(2, v);
  }

  let changeM = e => {
    let v = e.target.value;

    if (!v.match(/^(|\d|0\d|10|11|12)$/))
      return;

    updateValue(1, v);
  }

  let changeY = e => {
    updateValue(0, e.target.value);
  }

  let leadZero = (e, pos) => {
    let v = parseInt(e.target.value);

    if (v < 10)
      updateValue(pos, "0" + v);
  }

  let blurYear = (e) => {
    let v = parseInt(e.target.value);

    if (v < 10)
      updateValue(0, "200" + v);
    else if (v < 30)
      updateValue(0, "20" + v);
    else if (v < 100)
      updateValue(0, "19" + v);
  }

  return <div>
    <Space>
      <div>
        <div>Month</div>
        <Input placeholder="MM" value={values[1]} onBlur={e => leadZero(e, 1)} onChange={changeM} style={{width: "50px"}} maxLength={2}/>
      </div>
      <div>
        <div>Day</div>
        <Input placeholder="DD" value={values[2]} onBlur={e => leadZero(e, 2)} onChange={changeD} style={{width: "50px"}} maxLength={2}/>
      </div>
      <div>
        <div>Year</div>
        <Input placeholder="YYYY" value={values[0]} onBlur={blurYear} onChange={changeY} style={{width: "65px"}} maxLength={4}/>
      </div>
    </Space>
  </div>
}
